import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { formatApiError } from "@/lib/api";

const HERO = "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export default function Login() {
  const { login } = useAuth();
  const { setOpen } = useCart();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      if (params.get("redirect") === "checkout") { navigate("/"); setOpen(true); }
      else navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={HERO} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest-deep/40" />
        <div className="absolute bottom-12 left-12">
          <span className="font-serif text-5xl text-alabaster">Vérité Botanica</span>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-clay">Bem-vindo de volta</p>
          <h1 className="mt-3 font-serif text-4xl font-light text-forest-deep">Entrar na conta</h1>
          <form onSubmit={submit} className="mt-8 space-y-5">
            {error && <p data-testid="login-error" className="border border-clay/40 bg-clay/10 px-4 py-3 font-sans text-sm text-clay">{error}</p>}
            <div>
              <label className="font-mono text-[10px] uppercase tracking-widest text-ink/60">E-mail</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required
                className="mt-1 w-full border border-borderlight bg-white px-4 py-3 font-sans text-sm outline-none focus:border-clay" />
            </div>
            <div>
              <label className="font-mono text-[10px] uppercase tracking-widest text-ink/60">Senha</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required
                className="mt-1 w-full border border-borderlight bg-white px-4 py-3 font-sans text-sm outline-none focus:border-clay" />
            </div>
            <button type="submit" disabled={busy} data-testid="login-submit"
              className="w-full bg-forest-deep py-4 font-mono text-xs uppercase tracking-[0.2em] text-alabaster transition-colors hover:bg-clay disabled:opacity-50">
              {busy ? "Entrando..." : "Entrar"}
            </button>
          </form>
          <p className="mt-6 font-sans text-sm text-ink/60">
            Não tem conta? <Link to="/registrar" data-testid="go-register" className="text-clay hover:underline">Criar conta</Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
}
